<script setup lang="ts">

import DashboardLayout from '@/onenetwork/layouts/DashboardLayout.vue'
import StatisticWidget from '@/onenetwork/components/widgets/StatisticWidget.vue'
import DeviceChart from '@/modules/statistic/components/DeviceChart.vue'
import UsageChart from '@/modules/statistic/components/UsageChart.vue'
import UsageRegionChart from '@/modules/statistic/components/UsageRegionChart.vue'
</script>

<template>
  <dashboard-layout currentRoute="reports/usage" page-title="Thống kê • Sử dụng app ">
    <div class="flex flex-col md:flex-row gap-3">
      <statistic-widget
        icon="fa6-solid:user-plus"
        title="Đăng ký hôm nay"
        :current-value="30"
        value-unit=""
        :growth-value="2"
        growth-value-unit="%"
        growth-description="so với hôm qua"
      />
      <statistic-widget
        icon="fa6-solid:user-plus"
        title="Đăng ký tháng này"
        :current-value="30"
        value-unit=""
        :growth-value="-20"
        growth-value-unit="%"
        growth-description="so với tháng trước"
      />
      <statistic-widget
        icon="jam:android-circle"
        title="Lượt tải Android"
        :current-value="30"
        value-unit=""
        :growth-value="20"
        growth-value-unit="%"
        growth-description="so với tháng trước"
      />
      <statistic-widget
        icon="jam:apple-circle"
        title="Lượt tải iOS"
        :current-value="30"
        value-unit=""
        :growth-value="50"
        growth-value-unit="%"
        growth-description="so với tháng trước"
      />
    </div>

    <div class="flex flex-col md:flex-row mt-5 gap-3">
      <div class="flex-5 md:flex-3">
        <div class="flex flex-col w-full md:flex-col gap-3">
          <Panel header="Biểu đồ theo thiết bị" class="flex-1 mb-5" toggleable>
            <UsageChart/>
          </Panel>
          <Panel header="Biểu đồ tỉ lệ tổng đăng ký theo khu vực" class="flex-1 mb-5" toggleable>
            <UsageRegionChart/>
          </Panel>
        </div>
      </div>
      <div class="flex-1 md:flex-1">
        <Panel header="Biểu đồ tỉ lệ tổng sử dụng theo thiết bị" class="mb-5" toggleable>
          <div class="flex w-full justify-center">
            <DeviceChart/>
          </div>
        </Panel>
        <Panel header="Biểu đồ tỉ lệ tổng sử dụng theo giới tính" toggleable>
          <div class="flex w-full justify-center">
            <DeviceChart/>
          </div>
        </Panel>
      </div>
    </div>

  </dashboard-layout>
</template>

<style scoped>

</style>
